import React from 'react'
import { makeStyles, Switch, Hidden, useClientOptions } from '@paintscout/ui'
import { getObjectLabels } from '@paintscout/util/builder'

const useStyles = makeStyles(
  {
    switch: {
      margin: 0,
      '@media print': {
        display: 'none'
      }
    }
  },
  { name: 'AmountHeadColumn' }
)
export default function AmountHeadColumn({
  consumer,
  disabled,
  onChange,
  showAmount,
  isEditable,
  hideLabel
}: {
  consumer: string
  isEditable?: boolean
  showAmount?: boolean
  disabled?: boolean
  hideLabel?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
}) {
  const classes = useStyles({})
  const { options } = useClientOptions()
  const { currency } = getObjectLabels({ options })
  const showSwitch = isEditable

  if (consumer === 'crew') {
    if (showSwitch) {
      return (
        <Switch
          className={classes.switch}
          data-testid="amount-column-switch"
          color={'default'}
          disabled={disabled}
          overlay={currency.symbol}
          onChange={onChange}
          checked={showAmount}
        />
      )
    } else {
      return (
        <Hidden smDown implementation="css">
          {hideLabel ? '' : 'Hours'}
        </Hidden>
      )
    }
  }

  if (consumer === 'customer') {
    if (showSwitch) {
      return (
        <Switch
          className={classes.switch}
          data-testid="amount-column-switch"
          color={'default'}
          disabled={disabled}
          onChange={onChange}
          overlay={currency.symbol}
          checked={showAmount}
        />
      )
    } else {
      return (
        <Hidden smDown implementation="css">
          {hideLabel ? '' : currency.symbol}
        </Hidden>
      )
    }
  }

  return null
}
